export default __webpack_public_path__ + "static/media/adentis-novo-logo-branco-horizontal.23b4defb.svg";